import { createReducer, field } from 'redux/shelf';
import { get, put } from 'redux/shelf/api';
import session from 'lib/session';

export const actions = {
  fetchFreeShipping: get`stickers/${session.getMerchant}/free-shipping`(field('freeShipping')),
  updateFreeShipping: put`stickers/${session.getMerchant}/free-shipping`(field('freeShipping')),
  fetchDiscount: get`stickers/${session.getMerchant}/discount`(field('discount')),
  updateDiscount: put`stickers/${session.getMerchant}/discount`(field('discount')),
}

export const reducer = createReducer(actions);
